import React from 'react';
import classNames from 'classnames';

import { miniGazelle } from '../../../../../helpers';
import ProLink from '../../../../shared/ProLink/ProLink';

const renderDiscontinuedSection = ({ location, showsDiscontinued, discontinuedCurrentLabel }) => (
    <div className={classNames('discontinued-buttons', 'tw-my-3')}>
        <div className={classNames('discontinued-wrapper', 'text-left')}>
            <ProLink to={`${location.pathname}?discontinued=${!showsDiscontinued}`} className="btn btn-blue">
                {miniGazelle.label(discontinuedCurrentLabel, true)}
            </ProLink>
        </div>
    </div>
);

export default renderDiscontinuedSection;
